export class Users  {
      UserID :  number;
      CompanyID :number  ;
      FirstName : string ;
      LastName : string ;
      Email : string ;
      Password : string ;
      Password2:string;
      Active : boolean  ;
      PublisherID : number ;
      // **** 2023-04-24 JFRH: NeedsHash: Password needs hashing for Login validation
      NeedsHash: boolean ;


    constructor(){
        this.UserID =  0;
        this.CompanyID =0  ;
        this.FirstName = "" ;
        this.LastName = "" ;
        this.Email = "" ;
        this.Password = "" ;
        this.Password2= "";
        this.Active = true  ;
        this.PublisherID = 0 ;

    }
}
